import {createAction} from 'redux-actions';
import {get} from 'lodash';
import config from '../../config';


export function getCurrentUser() {
  return async (dispatch) => {
    const token = sessionStorage.getItem("token");
    if (!token) return null;
    dispatch(createAction('fetchUserData')());
    const result = await fetch(`${config.apiBaseUrl}/v1/auth/user/`, {
      method: "GET",
      headers: {
        Authorization: "Token " + token,
      }
    });
    if (result.status === 401) {
      if (sessionStorage.getItem("token") !== null) {
        sessionStorage.removeItem("token")
        sessionStorage.removeItem("lastApiCall")
        location.reload();
      }
      return null;
    }
    const user = await result.json()
    const userWithOrganization = Object.assign({},
      {displayName: get(user, 'first_name') + ' ' + get(user, 'last_name')},
      {nickname: get(user, 'nickname')},
      {username: get(user, 'username')},
      {firstname: get(user, 'first_name')},
      {followedHearings: get(user, 'followed_hearings')},
      {votedSectionComments: get(user, 'voted_section_comments')},
      {facilitatorHearings: get(user, 'facilitator_hearings')},
      {membersHearings: get(user, 'members_hearings')},
      {lastname: get(user, 'last_name')},
      {answered_questions: get(user, 'answered_questions')},
      {adminOrganizations: get(user, 'admin_organizations', null)},
      {defaultOrganization: get(user, 'default_organization')},
      {hasStrongAuth: false},
      {missing_information: get(user, 'missing_information', null)},
      {is_superuser: get(user, 'is_superuser', false)},
      {avatar: get(user, 'avatar', null)},
    );
    return dispatch(createAction('receiveUserData')(userWithOrganization));
  }
}

export function updateCurrentUserWithPartial(partialToUpdate) {
  return async (dispatch,getState) => {
    const stateUser = getState().user.data
    const updatedUser = {
      ...stateUser,
      ...partialToUpdate
    }
    return dispatch(createAction('receiveUserData')(updatedUser));
  }
}